export enum SystemAvailabilityEnum {
  AVAILABLE = 'AVAILABLE',
  CAPTURE_ERROR = 'CAPTURE_ERROR',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  CLOSED = 'CLOSED',
}
